import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticesPosing from '../../images/characters/apprenticesPosing.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './song.md';
import markdownFile_fr_CA from './song.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadSong () {
  preloader([
    apprenticesPosing,
    apprenticesFlexArms
  ]);
}

function songSection ({ level, regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="song">

      {/* Get ready to sing level 1 & 2 */}
      { (i18n.lang === 'en' && (level === 1 || level === 2)) &&
        balloonSlide({
          id: 'get-ready',
          characterSide: 'right',
          characterImage: apprenticesFlexArms,
          html: md_i18n.getSubSectionAsHtml('Get Ready to Sing', 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml('Get Ready to Sing', 'Notes', false, regionData)
        })
      }

      {/* Standalone song in level 1 & 2 */}
      { (i18n.lang === 'en' && (level === 1 || level === 2)) &&
        videoSlide({
          id: 'song',
          notes: md_i18n.getSubSectionAsHtml('Standalone Song', 'Notes', false, regionData),
          youTubeId: md_i18n.getSectionMetadata('Standalone Song', 'YouTube', regionData)
        })
      }

      {/* Combined Intro and Chorus in levels 3 & 4 */}
      { (level === 3 || level === 4) &&
        videoSlide({
          id: 'song',
          notes: md_i18n.getSubSectionAsHtml(`Combo Intro Song Level ${level}`, 'Notes', false, regionData),
          youTubeId: md_i18n.getSectionMetadata(`Combo Intro Song Level ${level}`, 'YouTube', regionData)
        })
      }

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/03_song/songSection.jsx